import React, { useState, useEffect } from "react";
import {
  Chart as ChartJs,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import moment from "moment";
import "moment/locale/es";
import axios from "axios";
import {collection, getDocs, addDoc, query, doc} from 'firebase/firestore';
import db from "../../config/firebase";

ChartJs.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ReservationsGraphics = () => {
  const [chartData, setChartData] = useState({
    datasets: [],
  });

  const [chartOptions, setChartOptions] = useState({});

  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    const getMonths = (monthsToSubtract = 0) => {
      return moment().subtract(monthsToSubtract, "months").format("MMMM");
    };

    setChartOptions({
      responsive: true,
      plugins: {
        legend: {
          position: "top",
        },
        title: {
          display: true,
          text: "Reservas",
        },
      },
    });

    const petition = async () => {
      const q = query(collection(db, "reservation"));
      const querySnapshot = await getDocs(q);
      let reservationArray = [];
      querySnapshot.forEach((doc) => {
        reservationArray.push(doc.data());
      });
      addData(reservationArray);
    };

    const addData = (data) => {
      let usersFiltereds = [];
      for (let i = 4; i >= 0; i--) {
        usersFiltereds = [
          ...usersFiltereds,
          data.filter(
            (user) => moment(user.actionDate).format("MMMM") == getMonths(i)
          ).length,
        ];
      }

      setDataList(usersFiltereds);
    };

    petition();
  }, []);

  useEffect(() => {
    const getMonths = (monthsToSubtract = 0) => {
      return moment().subtract(monthsToSubtract, "months").format("MMMM");
    };

    const mappingMonths = () => {
      let monthsCant = [];
      for (let i = 4; i >= 0; i--) {
        monthsCant = [...monthsCant, getMonths(i)];
      }

      return monthsCant;
    };

    const getChartData = () => {
      return dataList;
    };

    setChartData({
      labels: mappingMonths(),
      datasets: [
        {
          label: "Reservas",
          data: getChartData(),
          borderColor: "rgb(53, 162, 235)",
          backgroundColor: "#53ca98",
        },
      ],
    });
  }, [dataList]);

  return (
    <>
      <Bar options={chartOptions} data={chartData} />
    </>
  );
};

export default ReservationsGraphics;
